import React, { useState, useEffect } from "react";

import useFetchObjectByPost from "../../../../components/Hooks/useFetchObjectByPost";
import { sto } from "../../../../Context/InshData";
import { uri } from "../../../../help/Api";
import GardUnit from "./GardUnit";
import LoadingPage from "../../../../services/LoadingPage";
const defaultAutos = {
  Safes: [],
};

export default function GardUnitCon() {
  
  const tb2 = {
    Safe: true,
    SafeEmp:true,
    stor: sto,
    parms: { 
        branch: sto.branchi  ,
        iempid: sto.empi,
        db_name:sto?.db_name
     },

  };

  const { object: AutoOptionsB, fetching: fetchAllS } = useFetchObjectByPost(
    uri + "GetD",
    tb2,
  );
  const tb = {
    wait: true,
    // Safes: true,
    Branches: true,
    groups: true,
    stor: sto,
    parms: { safe: -1,db_name:sto?.db_name},
  };

  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "Rept",
    tb
  );

  if (fetchAll || !AutoOptionsB?.Safes) return <LoadingPage />;

  return (
    <GardUnit
      {...{
        AutoOptions: AutoOptions?.Branches ? AutoOptions : defaultAutos,
        AutoOptionsB
      }}
    />
  );
}
